module.exports = __webpack_public_path__ + "img/1335069754.4ea6ff1b.jpg";